module.exports = __webpack_public_path__ + "static/media/jill1.bc8c820e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jill1.gif
// module id = 155
// module chunks = 0